module.exports = __webpack_public_path__ + "static/img/chejia_car_ei6.594690e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/VehicleInformation/chejia_car_ei6.png
// module id = Znfw
// module chunks = 19